// export const buses = [
//   { id: 1, name: "13-Seater Tempo Traveller", body: "Traveller", seats: "13", ac: "AC / Non-AC", image: "/vehicles/13tt.png" },
//   { id: 2, name: "17-Seater Tempo Traveller", body: "Traveller", seats: "17", ac: "AC / Non-AC", image: "/vehicles/17tt.png" },
//   { id: 3, name: "20-Seater Mini Bus", body: "Mini Bus", seats: "20", ac: "AC / Non-AC", image: "/vehicles/20mb.png" },
//   { id: 4, name: "24–26 Seater Mini Bus", body: "Mini Bus", seats: "24–26", ac: "AC / Non-AC", image: "/vehicles/26mb.png" },
//   { id: 5, name: "32-Seater Bus", body: "Bus", seats: "32", ac: "AC / Non-AC", image: "/vehicles/32bus.png" },
//   { id: 6, name: "35-Seater Luxury Bus", body: "Luxury Bus", seats: "35", ac: "AC / Non-AC", image: "/vehicles/35lux.png" },
//   { id: 7, name: "40–45 Seater Tourist Bus", body: "Tourist Bus", seats: "40–45", ac: "AC / Non-AC", image: "/vehicles/45tour.png" },
//   { id: 8, name: "49–53 Seater Luxury Coach", body: "Coach", seats: "49–53", ac: "AC", image: "/vehicles/53coach.png" },
//   { id: 9, name: "Volvo Multi-Axle Coach – 53 Seater", body: "Volvo Coach", seats: "53", ac: "AC", image: "/vehicles/volvo.png" },
//   { id: 10, name: "Sleeper Coach – 30–40 Berths", body: "Sleeper", seats: "30–40", ac: "AC / Non-AC", image: "/vehicles/sleeper.png" },
// ];



export const buses = [
  {
    id: 1,
    name: "13-Seater Tempo Traveller (AC / Non-AC)",
    image: "/images/gallery/bus/tt-13.jpg",

    gallery: [
      "/images/gallery/bus/tt-13.jpg",
      "/images/gallery/bus/tt-13-interior.jpg",
      // "/images/gallery/bus/tt-13-rear.jpg",
     
    ],

    body: "Tempo Traveller",
    seats: "12 + 1",
    doors: "4",
    engine: "Diesel",
    transmission: "Manual",
    fuel: "Diesel",
    ac: "AC / Non-AC"
  },
  {
    id: 2,
    name: "17-Seater Tempo Traveller (AC / Non-AC)",
    image: "/images/gallery/bus/tt-17.jpg",

    gallery: [
      "/images/gallery/bus/tt-17.jpg",
      "/images/gallery/bus/tt-17-interior.jpg",
      // "/images/gallery/bus/tt-17-side.jpg",
    ],

    body: "Tempo Traveller",
    seats: "16 + 1",
    doors: "4",
    engine: "Diesel",
    transmission: "Manual",
    fuel: "Diesel",
    ac: "AC / Non-AC"
  },
  {
    id: 3,
    name: "20-Seater Mini Bus (AC / Non-AC)",
    image: "/images/gallery/bus/minibus-20.jpg",

    gallery: [
      "/images/gallery/bus/minibus-20.jpg",
      "/images/gallery/bus/minibus-20-interior.jpg",
      // "/images/gallery/bus/minibus-20-rear.jpg",
 
    ],

    body: "Mini Bus",
    seats: "19 + 1",
    doors: "2",
    engine: "Diesel",
    transmission: "Manual",
    fuel: "Diesel",
    ac: "AC / Non-AC"
  },
  {
    id: 4,
    name: "24–26 Seater Mini Bus (AC / Non-AC)",
    image: "/images/gallery/bus/minibus-26.jpg",

    gallery: [
      "/images/gallery/bus/minibus-26.jpg",
      "/images/gallery/bus/minibus-26-interior.jpg",
      // "/images/gallery/bus/minibus-26-side.jpg",
    ],

    body: "Mini Bus",
    seats: "24–26",
    doors: "2",
    engine: "Diesel",
    transmission: "Manual",
    fuel: "Diesel",
    ac: "AC / Non-AC"
  },
  {
    id: 5,
    name: "32-Seater Bus (AC / Non-AC)",
    image: "/images/gallery/bus/bus-32.jpg",

    gallery: [
      "/images/gallery/bus/bus-32.jpg",
      "/images/gallery/bus/bus-32-interior.jpg",
      // "/images/gallery/bus/bus-32-rear.jpg",
    ],

    body: "Tourist Bus",
    seats: "32",
    doors: "2",
    engine: "Diesel",
    transmission: "Manual",
    fuel: "Diesel",
    ac: "AC / Non-AC"
  },
  {
    id: 6,
    name: "35-Seater Luxury Bus (AC / Non-AC)",
    image: "/images/gallery/bus/luxury-35.jpg",

    gallery: [
      "/images/gallery/bus/luxury-35.jpg",
      "/images/gallery/bus/luxury-35-interior.jpg",
      // "/images/gallery/bus/luxury-35-side.jpg",
    ],

    body: "Luxury Bus",
    seats: "35",
    doors: "2",
    engine: "Diesel",
    transmission: "Manual",
    fuel: "Diesel",
    ac: "AC / Non-AC"
  },
  {
    id: 7,
    name: "40–45 Seater Tourist Bus (AC / Non-AC)",
    image: "/images/gallery/bus/bus-45.jpg",

    gallery: [
      "/images/gallery/bus/bus-45.jpg",
      "/images/gallery/bus/bus-45-interior.jpg",
      // "/images/gallery/bus/bus-45-side.jpg",
    ],

    body: "Tourist Bus",
    seats: "40–45",
    doors: "2",
    engine: "Diesel",
    transmission: "Manual",
    fuel: "Diesel",
    ac: "AC / Non-AC"
  },
  {
    id: 8,
    name: "49–53 Seater Luxury Coach – AC",
    image: "/images/gallery/bus/luxury-53.jpg",

    gallery: [
      "/images/gallery/bus/luxury-53.jpg",
      "/images/gallery/bus/luxury-53-interior.jpg",
      // "/images/gallery/bus/luxury-53-rear.jpg",
    ],

    body: "Luxury Coach",
    seats: "49–53",
    doors: "2",
    engine: "Diesel",
    transmission: "Manual / Automatic",
    fuel: "Diesel",
    ac: "AC"
  },
  {
    id: 9,
    name: "Volvo Multi-Axle Coach (9400 / B11R) – 53 Seater – AC",
    image: "/images/gallery/bus/volvo-53.jpg",

    gallery: [
      "/images/gallery/bus/volvo-53.jpg",
      "/images/gallery/bus/volvo-53-interior.jpg",
      // "/images/gallery/bus/volvo-53-side.jpg",
    ],

    body: "Volvo Coach",
    seats: "53",
    doors: "2",
    engine: "Diesel",
    transmission: "Automatic",
    fuel: "Diesel",
    ac: "AC"
  },
  {
    id: 10,
    name: "Sleeper Coaches (30–40 Berths – AC / Non-AC)",
    image: "/images/gallery/bus/sleeper-40.jpg",

    gallery: [
      "/images/gallery/bus/sleeper-40.jpg",
      "/images/gallery/bus/sleeper-40-interior.jpg",
      // "/images/gallery/bus/sleeper-40-berths.jpg",
   
    ],

    body: "Sleeper Coach",
    seats: "30–40 Berths",
    doors: "1–2",
    engine: "Diesel",
    transmission: "Manual / Automatic",
    fuel: "Diesel",
    ac: "AC / Non-AC"
  }
];
